"use strict";

angular.module('app.modals.dateTimePicker', [])

    .controller('dateTimePickerModalCtrl', ['$scope', 'dateTimeObject', 'close', 'dateTimeOptionsObject', '$translate', 'xCenterConfig', 'API',
        function($scope, dateTimeObject, close, dateTimeOptionsObject, $translate, xCenterConfig, API) {
            var opt = {
                date: true,
                time: true,
                isNextDay: false,
                months: 1,
                start: moment(),
                filter: undefined,
                astroData: {},
                pickerTemplate: 'views/form/datepicker.html',
                template: 'views/form/datepicker.html'
            };
            var localizations = {};

            $scope.close = function(a) {
                if (a == true) {
                    var result;

                    result = moment($scope.dateTimeObject).set({
                        'seconds': 0,
                        'milliseconds': 0
                    });
                    if ($scope.dateTimeOptionsObject.asUTC == true) {
                        result = moment.utc(result);
                    }

                    if ($scope.dateTimeOptionsObject.astroData.shouldActivateAstro) {
                        result = {
                            DateTime: (
                                $scope.chosenAstroValueDdl === 0
                                    ? result
                                    : $scope.dateTimeObject
                                        .set({
                                            'milliseconds': 0
                                        })
                                    ),
                            AstroType: $scope.chosenAstroValueDdl,
                            AstroOffset: +$scope.dateTimeOptionsObject.astroData.astroOffset || 0
                        };
                    }

                    close(result);
                } else {
                    close();
                }
            };

            var geoCords;
            var geoCordsLoading = false;
            function geoCordsPromise() {
                var api = new API();
                var readValuesParams = {
                    'DatapointValues': [
                        {
                            'DeviceId': xCenterConfig.var.guid_Empty,
                            'DatapointConfigId': xCenterConfig.datapointsDateTime.Longitude
                        },
                        {
                            'DeviceId': xCenterConfig.var.guid_Empty,
                            'DatapointConfigId': xCenterConfig.datapointsDateTime.Latitude
                        }
                    ],
                    IgnoreErrors: false
                };

                return api.Datapoint.ReadValues(readValuesParams).$promise;
            }

            function guessAstroTime() {
                if (geoCords[1].Value === 0 && geoCords[0].Value === 0) {
                    $scope.allowSave = false;
                    $scope.textBeforeDate = localizations.GeoCoordinatesMissing;
                    $scope.dateTimeObject = undefined;
                    return;
                }

                // SunCalc is a library for calculating sun/moon positions and phases.
                // https://github.com/mourner/suncalc
                // (/*Date*/ date, /*Number*/ latitude, /*Number*/ longitude)
                // For reference use https://www.esrl.noaa.gov/gmd/grad/solcalc/
                let times = SunCalc.getTimes(
                                    /* It is important to set the day to midday. Otherwise the algorithm
                                    tries to find previous sunrise / next sunset from current time. */
                                    moment($scope.dateTimeObject).set({ hours: 12 }),
                                    geoCords[1].Value,
                                    geoCords[0].Value
                                );

                let sunriseSunset;
                if ($scope.chosenAstroValueDdl === 1) {
                    /* Correction to match time calculated on the server. */
                    sunriseSunset = moment(times.sunrise).subtract(103, 'seconds');
                } else if ($scope.chosenAstroValueDdl === 2) {
                    /* Correction to match time calculated on the server. */
                    sunriseSunset = moment(times.sunset).subtract(141, 'seconds');
                }

                let boundSunriseSunset;
                if (moment(sunriseSunset).add(+$scope.dateTimeOptionsObject.astroData.astroOffset, 'minutes').isBetween(moment(sunriseSunset).startOf('day'), moment(sunriseSunset).endOf('day'), null, [])) {
                    /* All good, offset is in allowed ranges. */
                    boundSunriseSunset = moment(sunriseSunset).add(+$scope.dateTimeOptionsObject.astroData.astroOffset, 'minutes');

                } else if (moment(sunriseSunset).add(+$scope.dateTimeOptionsObject.astroData.astroOffset, 'minutes').isBefore(moment(sunriseSunset).startOf('day'))) {
                    /* To early, set to 00:00 */
                    boundSunriseSunset = moment(sunriseSunset).set({
                        hour: 0,
                        minutes: 0,
                        seconds: 0,
                        milliseconds: 0
                    });

                } else if (moment(sunriseSunset).add(+$scope.dateTimeOptionsObject.astroData.astroOffset, 'minutes').isAfter(moment(sunriseSunset).endOf('day'))) {
                    /* To early, set to 24:00 */
                    boundSunriseSunset = moment(sunriseSunset).set({
                        hour: 24,
                        minutes: 0,
                        seconds: 0,
                        milliseconds: 0
                    });

                }



                $scope.textBeforeDate = '';
                if (boundSunriseSunset.isBetween(moment(), moment().endOf('day'), null, [])) {
                    $scope.textBeforeDate += localizations.Today + ' ' + localizations.Around;
                }
                else {
                    $scope.textBeforeDate += localizations.AtNearest + ' ' + boundSunriseSunset.format('dddd') + ' ' + localizations.Around;
                }

                $scope.boundDateTimeObject = boundSunriseSunset;
                $scope.dateTimeObject = sunriseSunset;
            }

            var oldDate;
            $scope.setDateTimeObject = function() {
                if ([1,2].includes($scope.chosenAstroValueDdl)) {
                    if (geoCords) {
                        guessAstroTime();
                    } else {
                        if (!geoCordsLoading) {
                            geoCordsLoading = true;
                            geoCordsPromise()
                                .then(function (data) {
                                    geoCordsLoading = false;
                                    geoCords = data;
                                    guessAstroTime();
                                });
                        }
                    }
                }
                else {
                    $scope.allowSave = true;

                    /* The next day is already set, do nothing. */
                    if ($scope.time.oldHour === 24 && $scope.time.hour === 24) {
                        return;
                    }

                    if ($scope.dateTimeOptionsObject.asUTC === true) {

                       $scope.dateTimeObject = moment.utc($scope.dateTimeObject).set({
                           hour: $scope.time.hour,
                           minutes: $scope.time.mins
                       });

                   } else {
                       $scope.dateTimeObject = moment($scope.dateTimeObject).set({
                           hour: $scope.time.hour,
                           minutes: $scope.time.mins
                       });

                   }

                   /* An user set hour from 24 to any, subtract a day. */
                   if ($scope.time.oldHour === 24 && $scope.time.hour !== 24) {
                       $scope.dateTimeObject.subtract(1, 'days');
                   }

                   /* An user set hour to 24, it is needed to display -1 day from the current day. */
                   if ($scope.time.hour === 24) {
                       $scope.subtractedDate = moment($scope.dateTimeObject).subtract(1, 'days');
                   } else {
                       $scope.subtractedDate = moment($scope.dateTimeObject);
                   }
                }

                console.log('time: ' + $scope.dateTimeObject.format(xCenterConfig.timeprogram.defaultEntryTimeFormat));
                oldDate = $scope.dateTimeObject.clone();
            };


            var oldOffset;
            function activateSunriseSunset(astroData) {
                loadLocalizations();
                $scope.possibleValuesTimeSettings = {
                    '0': localizations.Time_Manual,
                    '1': localizations.Time_Sunrise,
                    '2': localizations.Time_Sunset,
                };
                $scope.chosenAstroValueDdl = astroData.astroType || 0;
                oldOffset = astroData.astroOffset;
            }

            $scope.valuesTimeSettingsDdlChanged = function(result) {
                $scope.chosenAstroValueDdl = (+result.value);
                $scope.setDateTimeObject();
            };

            $scope.filterKeys = (event) => {
                if (event.charCode === 8 || event.charCode === 0) {
                    return null;
                }
                else if (
                    (event.charCode >= 48 && event.charCode <= 57)
                    || event.charCode === 45 // -
                ) {
                    return event.charCode;
                }
                event.preventDefault();
                return null;
            };


            $scope.filterInput = (fullOffset) => {
                if (fullOffset === '') {
                    $scope.dateTimeOptionsObject.astroData.astroOffset = '';
                    oldOffset = 0;
                    $scope.setDateTimeObject();
                    return;
                }
                else if (fullOffset === '-') {
                    /* Wait for a next char. */
                    return;
                }

                if (Number.isInteger(+fullOffset)) {
                    /* Valid input. A number or empty, remember the value. */
                    $scope.dateTimeOptionsObject.astroData.astroOffset = +fullOffset;
                    oldOffset = +fullOffset;
                }
                else {
                    /* Some unknown invalid input, better to revert to a correct value. */
                    $scope.dateTimeOptionsObject.astroData.astroOffset = +oldOffset;
                }


                $scope.setDateTimeObject();
            };

            $scope.time = {
                hour: 0,
                mins: 0
            };

            /* The logic for this method is to reduce the calendar date 'jumping'.
               When an user selects 24:00 in any day, the selected day will 'jump'
               to a previous day. To reduce number of jumps, when an user
               selects 24:00 and then selects any other day, the time will
               be changed to 23:59 and therefore no jump will occur. */
            function mightyCalendarOnDayClick(newDate) {
                /* An user clicked the same day in the calendar, do nothing. */
                if (oldDate.isSame(newDate)) {
                    return;
                }
                oldDate = newDate.clone();

                if ($scope.time.hour === 24) {
                    $scope.time = {
                        hour: 23,
                        mins: 59
                    };
                    newDate.set({ 'hours': $scope.time.hours, 'minutes': $scope.time.mins });
                }

                $scope.dateTimeObject = moment(newDate);
                $scope.subtractedDate = newDate.clone();

                $scope.setDateTimeObject();
            }

            $scope.init = function() {
                // extract hours and seconds
                if (dateTimeObject == undefined) {
                    close();
                }
                $scope.dateTimeOptionsObject = angular.merge(opt, dateTimeOptionsObject);
                //angular.extend(opt, dateTimeOptionsObject);
                $scope.dateTimeObject = dateTimeObject;
                oldDate = moment($scope.dateTimeObject);
                $scope.allowSave = true;

                /* No utc time, an user wants to see time in their pc locale. */
                /* Check if it's a utc . In scenes we handy only UTCs. User dont want to see 15 if he set 14 one step before.*/
                var m;

                if ($scope.dateTimeOptionsObject.asUTC == true) {
                    m = moment.utc($scope.dateTimeObject);
                    //$scope.asLocale = false;
                } else {
                    m = moment($scope.dateTimeObject);
                    //$scope.asLocale = true;
                }
                if ($scope.dateTimeOptionsObject.astroData.astroOffset) {
                    m.subtract(+$scope.dateTimeOptionsObject.astroData.astroOffset, 'minutes');
                }


                console.log('m: ' + m.format(xCenterConfig.timeprogram.defaultEntryTimeFormat));
                // O.k. it's a Scene DateTimeObject and we have 24hours
                if ($scope.dateTimeOptionsObject.isNextDay) {
                    $scope.time = {
                        hour: 24,
                        mins: 0
                    };
                } else {
                    $scope.time = {
                        hour: m.hours(),
                        mins: m.minutes()
                    };
                }
                $scope.time.oldHour = $scope.time.hour;
                $scope.time.oldMins = $scope.time.mins;

                if ($scope.dateTimeOptionsObject.astroData.shouldActivateAstro) {
                    if ($scope.dateTimeOptionsObject.isNextDay) {
                        $scope.dateTimeObject = $scope.dateTimeObject.subtract(1, 'days');
                    }

                    activateSunriseSunset($scope.dateTimeOptionsObject.astroData);
                } else {
                    $scope.chosenAstroValueDdl = 0;
                }

                if (!dateTimeOptionsObject.hideDate) {
                    $scope.dateTimeOptionsObject.callback = mightyCalendarOnDayClick;
                }

                $scope.setDateTimeObject();
            };
            $scope.init();

            $scope.$watch('time.hour', function(value) {
                if (value === 24) {
                    $scope.time.mins = 0;
                    $scope.time.oldMins = $scope.time.mins;
                }
                $scope.setDateTimeObject();
                $scope.time.oldHour = $scope.time.hour;
            });

            $scope.$watch('time.mins', function(value) {
                if ($scope.time.hour !== 24) {
                    $scope.setDateTimeObject();
                }
                $scope.time.oldMins = $scope.time.mins;
            });

            function loadLocalizations() {
                localizations.Time_Manual = $translate.instant('SCENE_Timeprogram');
                localizations.Time_Sunrise = $translate.instant('GENERAL_Sunrise');
                localizations.Time_Sunset = $translate.instant('GENERAL_Sunset');

                localizations.Around = $translate.instant('SCENE_Timeprogram_Around');
                localizations.Today = $translate.instant('SCENE_Timeprogram_Today');
                localizations.AtNearest = $translate.instant('SCENE_Timeprogram_AtNearest');

                localizations.GeoCoordinatesMissing = $translate.instant('SCENE_Timeprogram_GeoCoordinatesMissing');
            }
        }
    ])

    .factory('dateTimePickerModal', ['ModalService', function(ModalService) {
        return function(dateTimeObject, dateTimeOptionsObject) {
            return ModalService.showModal({
                templateUrl: "views/modals/dateTimePicker.html",
                controller: 'dateTimePickerModalCtrl',
                inputs: {
                    dateTimeOptionsObject: dateTimeOptionsObject,
                    dateTimeObject: dateTimeObject
                }
            });
        };
    }]);
